export default "__VITE_ASSET__9lAPefEw__"